import { call, take, put } from 'redux-saga/effects';
import axios from 'axios';

const endpoint = 'https://www.yisumatica.org.il/users/publicaccess/login/';

function* signIn(): Generator<any, any, any> {
  while (true) {
    try {
      // Wait for login action
      const action = yield take('LOG_IN_SAGA'); // should include payload with credentials
      console.log('[LOGIN SAGA] Received LOG_IN_SAGA with:', action.payload);

      const { email, password } = action.payload;

      // ✅ Call actual login endpoint with credentials
      const response = yield call(axios.post, endpoint, { email, password });

      const user = response.data.user; // or: const user = response.data; (based on your actual API)

      // Store session info (localStorage, Redux, etc.)
      localStorage.setItem('loggedInYisumatica', 'true');
      localStorage.setItem('userId', user.id);

      // ✅ Fire Ministry of Education login tracking
      yield put({
        type: 'RECORD_USER_LOGIN',
        payload: {
          userId: user.id,
          gradeAccess: user.gradeAccess,
          userFoundInTables: true,
          plus: user.plus,
          userExists: true,
          subscriptionExpired: false
        }
      });

      // ✅ Redirect
      window.location.assign('https://www.yisumatica.org.il');

    } catch (err) {
      console.error('[LOGIN SAGA ERROR]', err);
    }
  }
}

export default signIn;
